import styled from '@emotion/styled'

import { colors, weights } from '@/styles/theme'
import { LegiaBlack, Text1 } from '@/styles/typography'
import { mediaUp } from '@/styles/media'
import { focusVisible } from '@/styles/mixins'

export const Container = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;

  ${mediaUp('lg')} {
    padding: 80px 0;
  }
`

export const ToggleViewButton = styled(Text1)<{ active: boolean }>`
  ${focusVisible};
  cursor: pointer;
  font-weight: ${weights.black};
  margin: 0 20px;

  color: ${props =>
    props.active ? `${colors.twilightBlue}` : `${colors.darkSkyBlue}`};

  .legia-warszawa & {
    ${LegiaBlack};
    color: ${props =>
      props.active ? `var(--mainCustom)` : `var(--accentFirstCustom)`};
  }
`
